export const SketchObjectType = {
  POINT: 'point',
  LINE: 'line',
  POLYLINE: 'polyline',
  IMAGE: 'imageObject',
  OVAL: 'oval',
  POLYGON: 'polygon',
  RECTANGLE: 'rectangle',
  TEXT: 'text'
};
